import React, { useState, useRef } from "react";
import Modal from "./Modal/Modal";
import { GAME_STATUS, BOARD_TILE_STATUSES } from "../CrossoverGridTrivia"
import { getStatistics } from "../statistics";
import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { observer } from "mobx-react-lite";
import { Button } from "@mui/material";
import Colors from "../../../Colors";
import {
  getTimeToMidnight,
  formatPercent,
  copyToClipboard,
  formatPercent1Decimal,
} from "./util";
import useMediaQuery from "@mui/material/useMediaQuery";
import prime_games from "../../../assets/prime_gaming_logo.png";
import useTheme from "@mui/styles/useTheme";

const PromoSection = ({ children }) => {
  const theme = useTheme();
  return (
    <Paper
      style={{
        borderRadius: theme.shape.borderRadius,
        padding: theme.spacing(2),
        margin: theme.spacing(2, 0),
        textAlign: 'center',
        backgroundColor: theme.palette.mode === 'dark' ? '#333' : '#f5f5f5', // Adjust background color based on theme mode
        boxShadow: theme.shadows[1], // Optional, for a slight elevation effect
        fontFamily: "'font-prime', sans-serif" // Apply 'font-prime' font family directly
      }}
    >
      {children}
    </Paper>
  );
};
const Centered = ({ children }) => {
  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        alignContent: "center",
        justifyContent: "center",
      }}
    >
      {children}
    </div>
  );
};


const CenteredText = ({ children }) => {
  return (
    <Centered>
      <Typography variant="body1">{children}</Typography>
    </Centered>
  );
};

const SectionBlock = ({ children, topBottomPadding = "15px" }) => {
  return (
    <div style={{ width: "100%", padding: `${topBottomPadding} 0px` }}>
      {children}
    </div>
  );
};

const EMOJIS = {
  YELLOW: "🟨",
  GREEN: "🟩",
  BLACK: "⬜️",
};
const getShareString = ({ game, prompt, rowPercentile }) => {
  return {
    title: `Crossover Trivia  @CrossoverGrid @PrimeGaming ${game.row}/5`,
    prompt,
    emojisLines: game.board
      .map((row, i) => {
        return i < game.row
          ? row
              .map(({ status }) => {
                if (status == BOARD_TILE_STATUSES.PRESENT) {
                  return EMOJIS.YELLOW;
                } else if (status == BOARD_TILE_STATUSES.CORRECT) {
                  return EMOJIS.GREEN;
                } else {
                  return EMOJIS.BLACK;
                }
              })
              .join(" ")
          : "";
      })
      .slice(0, game.row),
    percentileText:
      !isNaN(rowPercentile) && rowPercentile != null
        ? `Top ${formatPercent1Decimal(rowPercentile)}`
        : undefined,
  };
};

const Header = () => {
  return (
    <div style={{ width: "100%" }}>
      <div
        style={{
          margin: "auto",
          padding: 15,
          paddingBottom: 0,
          textAlign: "center",
        }}
      >
        <Typography style={{ fontWeight: 600 }} variant="h5" gutterBottom>
          Thanks for playing
        </Typography>
      </div>
    </div>
  );
};

const StatBlock = ({ label, value }) => {
  const wideScreen = useMediaQuery("(min-width:410px)");

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignContent: "space-between",
        padding: `0px ${wideScreen ? 10 : 5}px`,
      }}
    >
      <Centered>
        <Typography variant={"h3"}>
          {value != undefined && value != null ? value : "-"}
        </Typography>
      </Centered>
      <Centered>
        <Typography
          style={{
            fontSize: wideScreen ? "1rem" : "0.9rem",
          }}
          variant={"body1"}
        >
          {label}
        </Typography>
      </Centered>
    </div>
  );
};

const WinningStats = ({ wonGames, totalGames, currentStreak }) => {
  return (
    <div
      style={{
        display: "flex",
        alignContent: "center",
        justifyContent: "center",
      }}
    >
      <StatBlock label={"Games"} value={totalGames} />
      <StatBlock label={"Wins"} value={formatPercent(wonGames / totalGames)} />
      <StatBlock
        label={"Streak 🔥"}
        value={currentStreak != 0 ? currentStreak : "-"}
      />
    </div>
  );
};

const EmojiCard = ({ game, prompt, rowPercentile, win }) => {
  const ref = useRef(null);
  const { title, emojisLines, percentileText } = getShareString({
    game,
    prompt,
    rowPercentile,
  });

  const percentile = win && percentileText ? percentileText : "";

  const shareText = `${title}\n${prompt}\n${emojisLines.join(
    "\n"
  )}\n\n${percentile}`;

  return (
    <React.Fragment>
      <div
        style={{
          // width: "50%",
          // minWidth: 200,
          // maxWidth: 300,
          padding: "0px 0px",
          margin: "auto",
          // backgroundColor: "black",
          background: 'none'
          // background: "linear-gradient(to right, #eea849, #f46b45)"
        }}
      >
        <div
          style={{
            // margin: "auto",
            // width: "48%",
            // minWidth: 180,
            // maxWidth: 280,
            textAlign: "center",
          }}
        >
          <div style={{ margin: "auto", textAlign: "center" }}>
            {emojisLines.map((line) => {
              return (
                <Typography style={{ fontSize: '30px', lineHeight: '36px' }} variant="body1">
                  {line}
                </Typography>
              );
            })}
            {/* <Typography style={{ lineHeight: 1 }} variant="body1" gutterBottom>
              {title}
            </Typography> */}
            <Typography style={{ lineHeight: 1, marginTop: '20px', fontSize: '0.8rem', fontWeight: 'bold' }} variant="body1" gutterBottom>
            🏀🏈 Crossover Trivia #3
              </Typography>
            <Typography style={{ lineHeight: 1, paddingTop: '10px' }} variant="body1" gutterBottom>
              {prompt}
            </Typography>
            {win && percentileText ? (
              <React.Fragment>
                <Typography
                  style={{ lineHeight: 1, paddingTop: 15 }}
                  variant="body1"
                  gutterBottom
                >
                  {percentile}
                </Typography>
              </React.Fragment>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
      <div style={{ margin: "auto", textAlign: "center", paddingTop: 15 }}>
        <Button
          variant="contained"
          style={{ backgroundColor: Colors.TWITTER_COLOR }}
          onClick={(event) => {
            copyToClipboard(`${title}\n${prompt}\n` + emojisLines.join("\n"));
            window.open(
              `https://twitter.com/intent/tweet?text=${encodeURI(shareText)}`
            );
          }}
        >
          Tweet
        </Button>
        <div style={{ display: "inline", paddingRight: 10 }}></div>
        <Button
          ref={ref}
          variant="contained"
          style={{ backgroundColor: Colors.GREEN }}
          onClick={(event) => {
            event.stopPropagation();
            copyToClipboard(shareText);
            ref.current.innerHTML = "Copied!";
            ref.current.style.backgroundColor = "#eea849";

            setTimeout(() => {
              ref.current.innerHTML = "Share";
              ref.current.style.backgroundColor = Colors.GREEN;
            }, 1000);
          }}
        >
          Share
        </Button>
      </div>
    </React.Fragment>
  );
};

const ButtonSection = ({ onClose, instagamLink }) => {
  const wideScreen = useMediaQuery("(min-width:440px)");

  return (
    <Centered>
      {/* updates, follow us */}
      {/* <CenteredText>Follow us on</CenteredText> */}
      <div
        style={{
          display: "flex",
          padding: "5px, 0px",
          width: "100%",
          flexDirection: wideScreen ? "row" : "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <SeeAnswerButton link={instagamLink} />
        <div style={{ width: 10, height: 10 }}></div>
        <FeedbackButton />
      </div>
    </Centered>
  );
};

const SeeAnswerButton = ({ link }) => {
  return (
    <IconButton
      label={"See Today's Answers"}
      icon={<LightbulbOutlinedIcon />}
      color={
        "-webkit-linear-gradient(left, rgb(238, 179, 90) 0%, rgb(224, 69, 106) 50%, rgb(148, 45, 178) 100%)"
      }
      onClick={() => {
        window.open(link || "https://www.instagram.com/crossovergrid/");
      }}
    />
  );
};

const FeedbackButton = () => {
  return (
    <IconButton
      label={"Give us Feedback"}
      icon={<CampaignOutlinedIcon />}
      color={Colors.GREEN}
      onClick={() => {
        window.open("https://forms.gle/iMp2ksRaYYSgjVez8");
      }}
    />
  );
};

const IconButton = ({ label, icon, onClick, color }) => {
  return (
    <Button
      variant="contained"
      style={{ background: color, width: 218, height: "100%" }}
      onClick={onClick}
      endIcon={icon}
    >
      <Typography style={{ fontWeight: 600, width: "100%" }}>
        {label}
      </Typography>
    </Button>
  );
};

export default observer(
  ({ open, onClose, game, prompt, statisticsPageText, instagamLink }) => {
    const wideScreen = useMediaQuery("(min-width:640px)");
    const theme = useTheme()
    // force state to update when CrossoverGridTrivia loads rowPercentile
    const [p, setP] = useState(undefined);
    game.onPercentileLoaded = ({ rowPercentile }) => {
      setP(p + 1);
    };

    const timeDifference = getTimeToMidnight();

    const { wonGames, totalGames, currentStreak, rowPercentile } =
      getStatistics();

    return (
      <Modal open={open} onClose={onClose}>
        <Header />

        {/* {!isNaN(wonGames) && !isNaN(totalGames) ? (
          <SectionBlock>
            <WinningStats
              wonGames={wonGames}
              totalGames={totalGames}
              currentStreak={currentStreak}
            />
          </SectionBlock>
        ) : (
          ""
        )} */}

        {game.status != GAME_STATUS.IN_PROGRESS ? (
          <SectionBlock>
            <EmojiCard
              game={game}
              prompt={prompt}
              rowPercentile={rowPercentile}
              win={
                currentStreak != undefined &&
                currentStreak != null &&
                currentStreak > 0
              }
            />
          </SectionBlock>
        ) : (
          ""
        )}

        {/* {statisticsPageText ? (
          <SectionBlock>
            <CenteredText>{statisticsPageText}</CenteredText>
          </SectionBlock>
        ) : (
          ""
        )} */}

<SectionBlock>
          <Centered>
            <Typography style={{ textAlign: "center" }} variant="body2">
              {`New Crossover Trivia in ${timeDifference.hours} hours and ${timeDifference.minutes} minutes! Not done playing?`}
            </Typography>
          </Centered>
        </SectionBlock>

    <SectionBlock>
    <PromoSection>
  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
    <a href="https://gaming.amazon.com/web-games?ref_=SM_CrossoverGrid_IGP" style={{ textDecoration: 'none', color: 'inherit' }}>
      {/* Apply the custom font to the Typography component */}
      <Typography component="p" variant="body2" style={{ marginBottom: theme.spacing(1) }} >
        Power up more games with Prime ↗
      </Typography>
      <img
        src={prime_games}
        alt="Prime Gaming Logo"
        style={{ width: "100px", filter: theme.palette.mode === "dark" ? "invert(1)" : "invert(0)" }}
      />
    </a>
  </div>
</PromoSection>
    </SectionBlock>



        {wideScreen ? <SectionBlock topBottomPadding="10px" /> : ""}

        {/* <SectionBlock topBottomPadding="15px">
          <ButtonSection instagamLink={instagamLink} />
        </SectionBlock> */}
      </Modal>
    );
  }
);
